import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isLoggedIn: false,
    walletInfo: {},
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setWalletInfo: (state, action) => {
            state.walletInfo = action.payload
        },
        clearWalletInfo : (state) => {
            state.walletInfo = {}
        },
        login: (state) => {
            state.isLoggedIn = true
        },
        logout: (state) => {
            state.isLoggedIn = false
        },
    },
})


export const { login, logout, setWalletInfo, clearWalletInfo } = userSlice.actions

export default userSlice.reducer
